<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h1>{{ $t('processes.title') }}</h1>
                <p class="subtitle-1 grey--text">{{ $t('processes.subtitle') }}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <ProcessRunTable />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ProcessRunTable from "../components/Processes/ProcessRunTable";

export default {
    name: "Processes",
    components: { ProcessRunTable }
};
</script>
